import { FormControl, FormHelperText } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ChipInput } from '../ChipInput/ChipInput'

export const ControlledChipInput = ({
  name,
  defaultValue = [],
  label,
  max = 0,
  helperText,
  prefix = ''
}) => {
  const { control, formState } = useFormContext()
  const hasError = formState.errors[name] !== undefined

  return (
    <>
      <FormControl fullWidth>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { value, onChange, ref } }) => {
            const handleChange = chips => {
              onChange(chips)
            }
            return (
              <ChipInput
                label={label}
                value={value}
                onChange={handleChange}
                max={max}
                prefix={prefix}
                inputRef={ref}
              />
            )
          }}
        />
        {helperText !== undefined && !hasError && (
          <FormHelperText id={`helper-text-${name}`}>
            {helperText}
          </FormHelperText>
        )}
        {formState.errors[name]?.message !== undefined && (
          <FormHelperText
            id={`error-helper-text-${name}`}
            error
            style={{ textAlign: 'right', paddingRight: 8 }}
          >
            {formState.errors[name]?.message}
          </FormHelperText>
        )}
      </FormControl>
    </>
  )
}
